// Operasyon Ekle / Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.operationForm';

export const productionOperationFormGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Operasyon nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Operasyon, sık tekrarlanan bir üretim işidir (ör. Kesim, Paketleme). Rotaya adım eklerken operasyonu seçtiğinizde adı, istasyonu, süreleri ve talimatı adıma hazır gelir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Operasyon'),
    body: t(`${G}.regions.body`, 'Kod, ad, istasyon, süreler'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kod ve ad'),
      text: t(`${G}.s1.text`, '"Kod" (1–30 karakter) ve "Ad" (1–200 karakter) zorunludur; aynı kod ikinci kez kullanılamaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Varsayılan istasyon'),
      text: t(`${G}.s2.text`, '"Varsayılan istasyon" bu işin genellikle yapıldığı iş istasyonudur; boş bırakılabilir. Adımın maliyeti, adımdaki istasyonun saatlik makine ve işçilik maliyetinden hesaplanır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Süreler ve talimat'),
      text: t(`${G}.s3.text`, '"Hazırlık (dk)" işe başlamadan önceki hazırlık, "Birim süre (dk)" bir birim üretim için geçen süredir; negatif olamaz. Planlanan süre = hazırlık + birim süre × miktar. "Talimat" isteğe bağlıdır; adıma kopyalanır ve atölye ekranında adım kartındaki (i) ile okunur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Operasyonda yaptığınız değişiklik, rotalara önceden eklenmiş adımları değiştirmez; operasyonu yeni seçtiğiniz adımlara gelir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Durum ve Kaydet'),
      text: t(`${G}.s4.text`, 'Anahtar operasyonun Aktif / Pasif durumunu belirler. "Kaydet"e basın; hata varsa pencerenin üstünde kırmızı mesaj çıkar.'),
    },
  ],
});
